<template>
	<div id='period'>
		 <el-date-picker
			type="month"
			:size="size"
      :clearable="false"
      :disabled = "disabled"
			placeholder="选择月"
			v-model='form.yearPeriodsStart'
			:picker-options = 'pickerBeginDateBefore'
			@change="dateChange($event, 'start')"
			format="yyyy 年 MM 期" :style='{ width: superStyles }'>
	    </el-date-picker>
	     <template v-if="isDaterange">
		    <span style="margin:0 10px">至</span>
		    <el-date-picker
		   		@change="dateChange($event, 'end')"
				type="month"
				:size="size"
        :disabled = "disabled"
        :clearable="false"
				v-model='form.yearPeriodsEnd'
				:picker-options='pickerBeginDateAfter'
				placeholder="选择月"
				format="yyyy 年 MM 期" :style='{ width: superStyles }'>
		    </el-date-picker>
	    </template>
	</div>
</template>
<script>
	export default {
		props: {
      disabled: {
        type: Boolean,
				default: false
      },
			size:{
				type:String,
				default:'small'
			},
			isDaterange: {
				type: Boolean,
				default: true
			},
			superStyles : {
				type: String,
				default: '145px'
			},
      isEmpty: {
        type: Boolean,
        default: false
      },
      // 结束日期是否是当期
      isEndTimeStu: {
        type: Boolean,
        default: false
      }
		},
		data() {
			return {
				form: {//条件筛选
					yearPeriodsStart:'',  // 当前选择开始日期
					yearPeriodsEnd: '',  // 当前选择结束日期
					defaultStartDate: '',
					defaultEndDate: '',
				},
				pickerBeginDateBefore: {
					disabledDate: (time)=>{
						 let startVal = this.getAccountPeriod.startTimeStamp;
						 let endVal = this.getAccountPeriod.endTimeStamp;
             if(this.isEndTimeStu) {
                let accountInfo = this.$getSessionStorage('accountInfo')
                endVal = accountInfo.yearPeriodTimeStamp
             }
						 if(startVal && endVal) {
						 	return time.getTime() < startVal || time.getTime() > endVal
						 }
					}
				},
				pickerBeginDateAfter: {
					disabledDate: (time)=>{
						let startVal = new Date(this.form.yearPeriodsStart);
						let endVal = this.getAccountPeriod.endTimeStamp;
            if(this.isEndTimeStu) {
              let accountInfo = this.$getSessionStorage('accountInfo')
              endVal = accountInfo.yearPeriodTimeStamp
            }
						// let superEnd;
						// if(startVal.getMonth() === 0) {
						// 	 superEnd =  startVal?new Date(startVal.getFullYear()+"/12/1") : '';
						// }else {
						// 	 superEnd =  startVal?new Date(startVal.getFullYear()+1+"/"+startVal.getMonth()+"/1") : '';
						// }
						// let endData=null;
						// if(endVal>superEnd) {
						// 	endData = superEnd;
						// }else {
						// 	endData = endVal;
						// }
						if(startVal && endVal) {
						 	return time.getTime() < startVal || time.getTime() > endVal
						 }

					}
				},
			}
		},
		created() {
			this.getAccountPeriods();
		},
		mounted() {
		},
		computed: {
			getAccountPeriod() {
				let res = this.$store.state.accountInfo.yearPeriods;
				this.form.defaultStartDate = res.startTimeStamp;
				this.form.defaultEndDate = res.endTimeStamp;
				return res;
			},
		},
		methods:　{
      setTimeRange(start,end) {
        if(!start || !end) return this.$message.warning("请传入开始和结束时间")
        let _start = new Date((start + '-01'));
        let _end = new Date((end + '-01'));
        this.form.yearPeriodsStart = _start;
        this.form.yearPeriodsEnd = _end;
      },
      // 清空时间
      clearTimeRange() {
        this.form = {
          yearPeriodsStart:'',  // 当前选择开始日期
					yearPeriodsEnd: '',  // 当前选择结束日期
					defaultStartDate: '',
					defaultEndDate: '',
        }
      },
      setYearPeriodsStart(date) {
        this.form.yearPeriodsStart = date
        this.form.yearPeriodsEnd = date
      },
			// 选择会计期间
			dateChange (val, name) {
				switch (name) {
					case 'start':
						this.form = Object.assign({}, this.form, {
							yearPeriodsStart: val,
							yearPeriodsEnd: val
						})
						break;
					case 'end':
						// 判断只能选定一年
						let startVal = new Date(this.form.yearPeriodsStart);
						let endVal = this.getAccountPeriod.endTimeStamp;
						let superEnd;
						if(startVal.getMonth() === 0) {
							 superEnd =  startVal?new Date(startVal.getFullYear()+"/12/1") : '';
						}else {
							 superEnd =  startVal?new Date(startVal.getFullYear()+1+"/"+startVal.getMonth()+"/1") : '';
						}
						let endData=null;
						if(endVal>superEnd) {
							endData = superEnd;
						}else {
							endData = endVal;
						}
						endData = new Date(endData);
						if(endData.getTime()<val.getTime()) {
							this.$set(this.form, 'yearPeriodsEnd', endData)
							this.$message.warning("目前不支持查询超过12个月跨度的数据！")
						}else {
							this.$set(this.form, 'yearPeriodsEnd', val)
						}
						break;
					}

				this.$emit('defaultTime', this.form)
			},
			// 获取会计期间/初始化数据
			getAccountPeriods() {
				console.log('2')
				let accountInfo = this.$getSessionStorage('accountInfo')

				if(!this.getAccountPeriod) {
					this.$store.dispatch('getAllYearPeriodsData')
				}
				this.form = Object.assign(this.form,{
					yearPeriodsStart: accountInfo.yearPeriodTimeStamp,
					yearPeriodsEnd: accountInfo.yearPeriodTimeStamp,
				})
        if(this.isEmpty) {
          this.form = {}
        }
				this.$emit('defaultTime' , this.form)
			},
		},
	}
</script>
<style lang='less'>
  #period {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }
	.el-month-table td.today .cell {
		font-weight: 100 !important;
		color: #606266 !important;
	}
	.el-month-table td.disabled .cell {
		font-weight: 100 !important;
		color:#C0C4CC !important;
	}
	.el-month-table td.current:not(.disabled) .cell {
	    color: #269D7B !important;
	}
	.el-month-table td .cell:hover {
	    color: #269D7B !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/dialog/accountingPeriod.vue